/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 19 2021 14:56:25 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.OCR_SERVICE;

export interface OcrResponse {
    ID:number;
		numdocument:string;
		datedocument:string;
		numevollis:string;
		numclient:string;
		nomclient:string;
		adresseclient:string;
		numcommande:string;
		datecommande:string;
		numbonlivraison:string;
		datelivraison:string;
		description:string;
		pourcremise:string;
		mthtinitial:string;
		mthtremise:string;
		mtttc:string;
		mtecopart:string;
		mttaxe:string;

}


export interface readFileParams {
  fileName: string;
}

/**
 * @tags Statistics Controller
 * @summary getStatProductionByCriteria
 */
export function readFile(
  params: readFileParams
) {
  return request.get<OcrResponse>(
    `${URL}/api/ocr/readFile` +
      prepareQueryParams({
        fileName: params.fileName,
      } as any)
  );
}


